import { useEffect, useRef } from 'react'
import { useIsActiveTurn } from '../../store'
import { isElectron } from '../../utils/runtimeUtils'
import { useActions } from '../../providers'
import { Button } from '@highlight/ui'
import { twMerge } from 'tailwind-merge'

const LoginPrompt = () => {
  const isChatLoading = useIsActiveTurn()
  const { onLogin } = useActions()
  const hasTracked = useRef(false)

  useEffect(() => {
    if (!hasTracked.current) {
      window.ampltd.trackEvent('Auth', {
        action: 'Chat login prompt shown',
      })
      hasTracked.current = true
    }
  }, [])

  const onClickLogin = () => {
    window.ampltd.trackEvent('Auth', {
      action: 'Chat login prompt',
      authenticationStep: 'Open login page',
    })
    onLogin()
  }

  const message = 'Sign in or create an account to continue chatting'

  const buttonStyle = twMerge('w-full', !isElectron && 'max-w-[472px]')

  if (isChatLoading) {
    return null
  }

  return (
    <div className="bg-background flex w-full flex-col items-center justify-center gap-4 rounded-2xl px-5 pb-5 pt-4 shadow-sm">
      <div className="text-foreground text-sm">{message}</div>
      <Button variant="primary" onClick={onClickLogin} className={buttonStyle}>
        Sign In
      </Button>
    </div>
  )
}

export default LoginPrompt
